import moment from 'moment';
import template from './am-operators-list.component.html';
import { isPrimaryUser } from '../../core/utilities/am-operators.util';
import { Operatorsfilter } from '../../core/models/am-helper.model';
import { filterData } from '../../../../functions/search.functions';

class AmOperatorsListController {
  constructor(amOperatorsService, amStoreService, usersService, $state, $scope, $ngRedux) {
    'ngInject';

    this.opService = amOperatorsService;
    this.amStore = amStoreService;
    this.usersService = usersService;
    this.$state = $state;
    this.operators = [];
    this.status = '';
    // holed operators ids need to excluded from the list
    this.excluded = [];
    this.operatorName = '';
    this.createOperatorStatus = '';
    this.createdOperator = null;
    this.isAdding = false;
    this.scope = $scope;
    this.store = $ngRedux;
    this.createForm = 'createForm';
    this.attrs = {};
    this.operatorName = '';
    this.expiryTimespans = [
      { id: 1, label: 'In a week', days: 7 },
      { id: 2, label: 'In 2 weeks', days: 14 },
      { id: 3, label: 'In a month', days: 30 },
      { id: 4, label: 'In 2 months', days: 60 },
      { id: 5, label: 'After 2 months', days: 60 },
      { id: 6, label: 'No expiry date', days: null },
      { id: 7, label: 'Expired', days: 0 },
    ];

    this.filter = new Operatorsfilter();
    this.filteredOperators = [];
    this.selectedExpiry = null;

    this.propertyKeys = ['name', 'codes.types', 'attrs.company_name'];

    this.addToDataLayer = (data) => window.dataLayer.push(data); // Google Analytics
  }

  get SelectedNumber() {
    return Object.keys(this.selected || {}).length;
  }

  get isPrimaryUser() {
    return isPrimaryUser(this.user);
  }

  $onInit() {
    this.getOperators();
    const unsubscribe = this.store.connect((state) => {
      const { user } = state;
      return { user };
    }, null)(this);
    this.scope.$on('$destroy', unsubscribe);
  }

  getOperators() {
    this.status = 'loading';
    this.opService
      .getOperators()
      .then((operators) => {
        this.operators = this.opService.filterByExcludedIds(operators, this.excluded);
        this.status = this.operators.length ? '' : 'no-data';
        this.filteredOperators = this.operators;
      })
      .catch(() => {
        this.status = 'error';
      });
  }

  onTriggerSearch(term, selectedTimeSpan) {
    this.filter.query = term ? `*${term}*` : '*';

    this.filteredOperators = filterData(this.operators, this.filter.query, this.propertyKeys);

    if (selectedTimeSpan) {
      this.onExpiryChange(selectedTimeSpan);
    }

    this.addToDataLayer({
      event: 'operatorSearching',
      data: {
        keyword: term,
        page: this.$state.current.name,
      },
    });
  }

  viewOperator(operator) {
    if (operator) {
      this.amStore.setVeiwedOperator(operator);
      this.$state.go('access-management.operator-view', {
        id: operator.id,
        name: operator.name,
      });
    }
  }

  openCreate() {
    this.isAdding = false;
    this.operatorName = '';
    this.attrs = {};
  }

  createOperatorRedirect() {
    if (!this.operatorName && this.operatorName === '') return;
    if (this.attrs.expiry) {
      this.attrs.expiry = moment.utc(this.attrs.expiry).format('L');
    }
    const operator = {
      name: this.operatorName,
      attrs: this.attrs,
      autoGeneratePIN: false,
      accessCodes: [],
    };
    this.createOperatorStatus = 'creating';
    this.opService
      .createOperator(operator)
      .then((created) => {
        this.createdOperator = created;
        this.createOperatorStatus = 'success';
        this.$state.go('access-management.operator-view', {
          id: created.id,
        });
      })
      .catch(() => {
        this.createOperatorStatus = 'failed';
      });
  }

  onExpiryChange(selectedTimeSpan) {
    this.selectedExpiry = selectedTimeSpan;
    const expiryFilteredOperators = [];

    if (selectedTimeSpan.days === null) {
      this.filteredOperators.forEach((op) => {
        if (!op.attrs.expiry) {
          expiryFilteredOperators.push(op);
        }
      });
    } else if (selectedTimeSpan.days === 0) {
      this.filteredOperators.forEach((op) => {
        if (op.attrs.expiry) {
          if (moment(op.attrs.expiry).isBefore(moment(), 'day')) {
            expiryFilteredOperators.push(op);
          }
        }
      });
    } else if (selectedTimeSpan.id === 5) {
      this.filteredOperators.forEach((op) => {
        if (op.attrs.expiry) {
          if (moment(op.attrs.expiry).isAfter(moment().add(selectedTimeSpan.days, 'days'))) {
            expiryFilteredOperators.push(op);
          }
        }
      });
    } else {
      this.filteredOperators.forEach((op) => {
        if (op.attrs.expiry) {
          // Makes sure that the time is 1 millisecond before today because moment isBetween will return false if it is 00:00:00:000
          const today = moment()
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0)
            .subtract(1, 'millisecond');
          // Makes sure that the time is 1 millisecond after the specified date because moment isBetween will return false if it is 23:59:59:999
          const future = moment()
            .add(selectedTimeSpan.days, 'days')
            .hour(23)
            .minute(59)
            .second(59)
            .millisecond(999)
            .add(1, 'millisecond');

          if (moment(op.attrs.expiry).isBetween(today, future, 'days')) {
            expiryFilteredOperators.push(op);
          }
        }
      });
    }

    this.filteredOperators = expiryFilteredOperators;
  }

  clearFilters() {
    this.selectedExpiry = null;

    this.onTriggerSearch(this.filter.query);
  }
}

export default {
  template,
  controller: AmOperatorsListController,
  controllerAs: 'opsVm',
  bindings: {
    selectMode: '<',
    selected: '=?',
    excluded: '<',
  },
};
